import React from 'react'
import './auth.styles.scss'

const AuthTemplate = (props) => {
    return (
        <div className="auth">
            <div className="bg"></div>
            <header>
                <h1><br/>Spring Journals - Admin</h1>
            </header>
            {props.children}
            <footer>
                <ul>
                    <li>
                        <a rel="noopener noreferrer" href="https://springjournals.net" >Main Site</a>
                    </li>
                    <li>
                        <a rel="noopener noreferrer" href="https://manuscripts.springjournals.net" target="_blank">Manuscript Submission</a>
                    </li>
                    <li>
                        <a rel="noopener noreferrer" href="https://springjournals.net/terms-conditions" target="_blank">Terms & Conditions</a>
                    </li>
                    <li>
                        <a rel="noopener noreferrer" href="https://springjournals.net/privacy-policy" target="_blank">Privacy Policy</a>
                    </li>
                </ul>
                <p>© 2023 Spring Journals. All rights reserved.</p>
            </footer>
        </div>
    )
}

export default AuthTemplate